<template>
    <div>
        <v-btn class="primary" 
                small 
                :disabled="disabled" 
                color="success"
                @click="buildReport">
                <v-icon medium class="mr-2">mdi-microsoft-excel</v-icon>
                <span class="pr-1">Create excel</span>
        </v-btn>
        <lin_prg_bar ref="prgbar"/>
    </div>
</template>

<script>

import lin_prg_bar from '@/components/ind_prg_horizontal';
    
export default{    
    components: {
        lin_prg_bar,
    },    
    props: {
        report_request: String,
        report_params: Object,
        report_program: String,
        show_progress: Boolean,
        interval: {
            type: Number,
            default: 1250
        }
    },    
    data(){
        return{
            disabled: false,
        }
    },
    computed: {
        reportRequest() {
            return typeof this.report_request === 'undefined' || this.report_request === null ? "report" : this.report_request;
        },
        showProgress() {
            return typeof this.show_progress === 'undefined' || this.show_progress === null ? false : this.show_progress;
        },        
        reportParams() {       
            return typeof this.report_params === 'undefined' || Object.keys(this.report_params).length === 0 || this.report_params === null ? {} : this.report_params;            
        }
    },    
    methods: {
        buildReport(){

            let params = new Object(); 

            let header = new Object();
            header.token = this.$session.get("ARES");
            header.clientSessionId = this.$session.id();
            header.request = this.reportRequest;

            params['header']=header;
            params[this.reportRequest]=this.reportParams;

            //console.log('params', JSON.stringify(params[this.reportRequest]));            

            this.disabled = true;
            if(this.showProgress){
                this.$refs.prgbar.open('Getting report data', true, this.interval);
            }
            console.log(this.report_program, params);
            this.$axios.post(this.report_program, params)
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                    this.$emit('hasError', res.data.error);
                } else {
                    //console.log("result", res);
                    window.open( res.data[this.reportRequest].filename,'_blank');
                }
            })
            .finally(() => {
                if(this.showProgress){
                    this.$refs.prgbar.close();
                }
                this.disabled = false;
            });
        }
    }
}

</script>
